import api from './api';

// Serviço para operações de alunos

export const checkMatricula = async (matricula, excludeId = null) => {
  try {
    const params = { matricula };
    if (excludeId) params.excludeId = excludeId;
    const response = await api.get('/alunos/check-matricula', { params });
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar matrícula:', error);
    return { success: false, emUso: false };
  }
};

export const fetchAlunos = async ({ page = 1, limit = 10, search = '', filters = {} } = {}) => {
  try {
    const params = { page, limit };
    if (search) params.nome = search;
    Object.assign(params, filters);
    
    const response = await api.get('/alunos', { params });
    return {
      success: true,
      data: response.data?.data || response.data,
      pagination: response.data?.pagination
    };
  } catch (error) {
    console.error('Erro ao buscar alunos:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: []
    };
  }
};

export const fetchAlunoById = async (id) => {
  try {
    const response = await api.get(`/alunos/${id}`);
    console.log('fetchAlunoById response:', response);
    return {
      success: true,
      data: response.data?.data || response.data
    };
  } catch (error) {
    console.error('Erro ao buscar aluno:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: null
    };
  }
};

export const createAluno = async (aluno) => {
  try {
    const response = await api.post('/alunos', aluno);
    return {
      success: true,
      data: response.data?.data || response.data,
      message: response.data?.message || 'Aluno criado com sucesso'
    };
  } catch (error) {
    console.error('Erro ao criar aluno:', error);
    console.log('Error response data:', error.response?.data);
    
    const errorData = error.response?.data;
    
    // O backend pode retornar validationErrors diretamente com estrutura { path, msg }
    // ou em 'details' com estrutura { field, message, value }
    let validationErrors = [];
    
    if (errorData?.validationErrors && Array.isArray(errorData.validationErrors)) {
      // Formato direto: { path, msg }
      validationErrors = errorData.validationErrors;
    } else if (errorData?.details && Array.isArray(errorData.details)) {
      // Formato antigo: { field, message, value } - converter para { path, msg }
      validationErrors = errorData.details.map(detail => ({
        path: detail.field,
        msg: detail.message,
        value: detail.value
      }));
    }
    
    return {
      success: false,
      error: errorData?.message || error.message,
      validationErrors: validationErrors,
      data: null
    };
  }
};

export const updateAluno = async (id, aluno) => {
  try {
    const response = await api.put(`/alunos/${id}`, aluno);
    return {
      success: true,
      data: response.data?.data || response.data,
      message: response.data?.message || 'Aluno atualizado com sucesso'
    };
  } catch (error) {
    console.error('Erro ao atualizar aluno:', error);
    console.log('Error response data:', error.response?.data);
    
    const errorData = error.response?.data;
    
    // O backend pode retornar validationErrors diretamente com estrutura { path, msg }
    // ou em 'details' com estrutura { field, message, value }
    let validationErrors = [];
    
    if (errorData?.validationErrors && Array.isArray(errorData.validationErrors)) {
      // Formato direto: { path, msg }
      validationErrors = errorData.validationErrors;
    } else if (errorData?.details && Array.isArray(errorData.details)) {
      // Formato antigo: { field, message, value } - converter para { path, msg }
      validationErrors = errorData.details.map(detail => ({
        path: detail.field,
        msg: detail.message,
        value: detail.value
      }));
    }
    
    return {
      success: false,
      error: errorData?.message || error.message,
      validationErrors: validationErrors,
      data: null
    };
  }
};

export const deleteAluno = async (id) => {
  try {
    const response = await api.delete(`/alunos/${id}`);
    return {
      success: true,
      message: response.data?.message || 'Aluno deletado com sucesso'
    };
  } catch (error) {
    console.error('Erro ao deletar aluno:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message
    };
  }
};

export const createAlunosBatch = async (main, dependents = []) => {
  try {
    const response = await api.post('/alunos/batch', { main, dependents });
    return {
      success: true,
      data: response.data?.data || response.data,
      message: response.data?.message || 'Alunos criados em lote com sucesso'
    };
  } catch (error) {
    console.error('Erro ao criar alunos em lote:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: null
    };
  }
};

export const fetchHistoricoAluno = async (id, { page = 1, limit = 20 } = {}) => {
  try {
    const response = await api.get(`/alunos/${id}/historico`, { params: { page, limit } });
    return {
      success: true,
      data: response.data?.data || response.data
    };
  } catch (error) {
    console.error('Erro ao buscar histórico do aluno:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: null
    };
  }
};

export const fetchAlunosConcluidosExport = async ({ extensaoId, cursoId } = {}) => {
  try {
    const params = {};
    if (extensaoId) params.extensaoId = extensaoId;
    if (cursoId) params.cursoId = cursoId;

    const response = await api.get('/alunos/exportar-concluidos', { params });
    return {
      success: true,
      data: response.data?.data || response.data
    };
  } catch (error) {
    console.error('Erro ao buscar alunos para exportar:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: []
    };
  }
};

// Export default para compatibilidade com componentes existentes
const alunoService = {
  listarAlunos: fetchAlunos,
  buscarAlunos: ({ search, ...params }) => fetchAlunos({ search, ...params }),
  buscarPorId: fetchAlunoById,
  criar: createAluno,
  atualizar: updateAluno,
  deletar: deleteAluno,
  criarLote: createAlunosBatch,
  buscarHistorico: fetchHistoricoAluno,
  exportarConcluidosExcel: fetchAlunosConcluidosExport,
};

export default alunoService;
